var styles = {"lottie-coin":"BenefitButton-module_lottie-coin__aEtZA"};

export { styles as default };
